import { useNetwork } from '../api/queries';
import { strings } from '../strings';

/** A network's name from the page's own query (the phone app bar, the breadcrumb); its kind label until loaded. */
export function NetworkName({ id }: { id: string }) {
  const network = useNetwork(id);
  return <>{network.data?.data.name ?? strings.networks.nav.kind}</>;
}
